import dynamic from 'next/dynamic';
import { PreferredPaymentHeaderProps } from './PreferredPaymentHeader.types';

export const PreferredPaymentHeader = dynamic<{ model: PreferredPaymentHeaderProps }>(() =>
  import('./PreferredPaymentHeader').then(mod => mod.PreferredPaymentHeader)
);
